'use client'

import React from 'react'

import { FeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'
import { GetProductPageQuery } from '@productsite-beta/src/graphql/generated/graphql-types'
import { ProductPageType } from '@productsite-beta/src/components/product-page'
import { GraphqlResult } from '@productsite-beta/src/components/utils/types'
import Tracking from '@productsite-beta/src/components/product-page/product-page-layout/product-page-layout-tracking'

type ProductPageProps = GraphqlResult<GetProductPageQuery> & {
  children: React.ReactNode
}

type Props = Omit<ProductPageProps, 'loading'>

const ProductPageLayoutClient = ({ data, children }: Props) => {
  const product = data?.productPageE4?.productResult as ProductPageType

  const excludeFromProductV2 = !!(
    !product.availability?.isAvailableForSale ||
    product?.variants?.productsWithoutVariantCombination.length ||
    product?.variants?.variantsInformation.find(variant => variant.values.length > 1)
  )

  return (
    <FeatureFlag
      trackOnly
      decideOptions={excludeFromProductV2 ? ['DISABLE_DECISION_EVENT'] : []}
      disableGTMEvent={excludeFromProductV2}
      flagKey="wt-product-page-v2">
      <Tracking product={product}>{children}</Tracking>
    </FeatureFlag>
  )
}

export default ProductPageLayoutClient
